const BaseModule = require('../../90_utils/base/BaseModule');

class PlyrVideo extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$playerWrapper = this.$el.find('.player-wrapper');
		this.$player 		= this.$el.find('.player');
		this.$playBtn    	= this.$el.find('button.play');
		this.$pauseBtn    	= this.$el.find('button.pause');
		this.$videoThumb 	= this.$el.find('.video-thumb');
		this.$domData 		= this.$el.find('.dom-data');

		this.id        		= this.$domData.attr('data-plyr-video-id');
		this.provider  		= this.$domData.attr('data-plyr-video-provider');
		this.autoplay  		= (this.$domData.attr('data-plyr-autostart') === true);

		this.controlsTemplate = this.$el.find('#plyr__controls_template').html();

		this.playerId;
		this.player;
		this.plyrInstance;

		this.isEnabled = false;
		this.isInitialized = false;
	}

	// basemodule methods

	_domReady(){

	}

	//

	_initVideo(forceAutoPlay){

		if(!this.isInitialized){

			this.playerId = `plyr-video-${++window.SETTINGS.vars.svgIndex}`;
			this.$player.attr('id', this.playerId);
			this.$player.addClass(this.playerId);

			this.$player.attr('data-type', this.provider);
			this.$player.attr('data-video-id', this.id);

			let autoplay = (forceAutoPlay === true) ? true : this.autoplay;

			this.player = plyr.setup('#' + this.playerId, {
				clickToPlay: false,
				disableContextMenu: true,
				hideControls: false,
				html: this.controlsTemplate,
				debug: false,
				autoplay: false //autoplay
			});

			this.isInitialized = true;

			this.player[0].on('ready', (e) => {

				this.plyrInstance = e.detail.plyr;

				this.plyrInstance.on('playing', (e) => {
					this.$el.triggerHandler('playing', {target:this, plyr:this.plyrInstance, originalEvent:e});
					this.$el.removeClass('video-pause');
					this.$el.addClass('video-playing');
				});

				this.plyrInstance.on('pause', (e) => {
					this.$el.triggerHandler('pause', {target:this, plyr:this.plyrInstance, originalEvent:e});
					this.$el.removeClass('video-playing');
					this.$el.addClass('video-pause');
				});

				this.$el.triggerHandler('ready', {target:this, plyr:this.plyrInstance, originalEvent:e});
				this.$el.addClass('video-ready');

				if(autoplay){
					this._play();
				}
			});
		}
	}

	//

	_addListeners(){

		this.$el.on('plyr-init', this._onInit.bind(this));
		this.$el.on('plyr-play', this._onPlayTriggered.bind(this));
		this.$el.on('plyr-pause', this._onPauseTriggered.bind(this));
		this.$el.on('plyr-destroy', this._onDestroyTriggered.bind(this));
	}

	_removeListeners(){

		this.$el.off('plyr-init', this._onInit.bind(this));
		this.$el.off('plyr-play', this._onPlayTriggered.bind(this));
		this.$el.off('plyr-pause', this._onPauseTriggered.bind(this));
		this.$el.off('plyr-destroy', this._onDestroyTriggered.bind(this));
	}

	//

	_onInit(){
		if ( !this.isInitialized ){
			this._initVideo();
		}
	}

	_onPlayClick(e){
		e.preventDefault();
		this._play();
	}

	_onPlayTriggered(){
		this._play();
	}

	_onPauseTriggered(){

	}

	_onDestroyTriggered(){

		this._stop();

		if(this.player && this.plyrInstance){
			this.plyrInstance.destroy();
			this.plyrInstance = null;
		}
	}

	//

	_play(){

		if(!this.isInitialized){
			this._initVideo(true);
		}
		else {

			if(this.player && this.plyrInstance){
				this.plyrInstance.play();
			}
		}
	}

	_pause(){

		if(this.player && this.plyrInstance){
			this.plyrInstance.pause();
		}
	}

	_stop(){

		if(this.player && this.plyrInstance){
			this.plyrInstance.stop();
		}
	}

	//

	_show(){}

	_hide(){}

	_enable(){ }
	_disable(){
		this._onDestroyTriggered();
	}

	_domUpdate(){

	}

	_resize(){

		if ( window.SETTINGS.breakpoint.minWidth('screen-small') ) {
			this.isEnabled = true;
		} else {
			this.isEnabled = false;
		}
	}
}

module.exports = PlyrVideo;
